import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import CompetitionsService, { CompetitionType, CompetitionTypes, CompetitionsUsersType, ListOfQuickLinks } from "../../services/CompetitionsService";
import { PrimaryButton, Spinner, SpinnerSize } from "@fluentui/react";
import styles from './index.module.sass';
import { currencyNeutreFormatter, decimalFormatter } from "../../utils/numberFormatter";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import portfolioModelWallets, { DataAndCartLines, ModelWallet } from "../../services/PortfolioModelWalletService";
import BackButton from "../../components/buttons/BackButton";
import CardWithInfo from "../../components/cardwithinfo/CardWithInfo";
import { CompetitionQuickLinks } from "../../components/competitionQuickLinks/CompetitionQuickLinks";
import * as L from "./layout.styles";
import CountdownTimer from "../../components/CountDownTimer/CountDownTimer";
import Auth from "../../Auth/Auth";
import { ErrorModal } from "../../components/Modals/ErrorModal";
import { formatCompetitionDate, parseCompetitionDate } from "@/utils/DateFormatter";
import { canJoinCompetitionWithPlans, ManagedPlanOnlyMessage } from "@/utils/CompetitionPlans";
import { sanitizeCompetitionHtml } from "@/utils/sanitizeCompetitionHtml";
import { SavingsPlanTypes } from "../../services/SavingsPlanService";
import { useDispatch } from "react-redux";
import { addCompetitionDataInLs, addLineEP, cartStateEP, clearCartEP, ICompetitionInfo, updateModelPortfolioIdEP, updateModelPortfolioNameEP } from "../../store/educationalcart/actions";
import { addCompetition, addCompetitionData, addLine, cartState, clearCart, updateModelPercentageTotal } from "../../store/cart/actions";
import { CartModesEP } from "../CartEducationalPlan/CartEducationalPlanScreen";
import { CartModes } from "../Cart/CartScreen";
import React from "react";

const options: Highcharts.Options =
{
	title:
	{
		text: '',
	},
	xAxis: { visible: false },
	yAxis: { visible: false },
	legend: { enabled: false },
	exporting: { enabled: false },
	credits: { enabled: false },
	chart:
	{
		type: 'bar',
		margin: 0,
		height: 24,
		backgroundColor: "transparent",
		borderColor: "transparent"
	},
	tooltip:
	{
		headerFormat: "",
		valueSuffix: '%',
		outside: true,
	},
	plotOptions:
	{
		bar:
		{
			stacking: 'percent',
			groupPadding: 0,
			pointPadding: 0,
			borderRadius: 4,
			borderColor: "transparent",
		},
	},
};

// Id de la competición: primero el del estado de navegación; si no llega (enlace de campaña, pestaña nueva,
// recarga o redirección tras el login), el sufijo numérico del slug "{nombre}-{id}" de la URL. 0 si no hay ninguno
const resolveCompetitionId = (stateCompetitionId: unknown, slug: string | undefined): number =>
{
	const fromState = parseInt(String(stateCompetitionId ?? ""), 10);
	if(!Number.isNaN(fromState) && fromState > 0)
	{
		return fromState;
	}

	const slugMatch = slug?.match(/(?:^|-)(\d+)$/);
	return slugMatch ? parseInt(slugMatch[1], 10) : 0;
};

const CompetitionPromotionated = () =>
{
	let history = useHistory();
	const [competition, setCompetition] = useState<CompetitionType>();
	const [banners, setBanners] = useState<ListOfQuickLinks>({ quicklinks: [] });
	const [competitionUsers, setCompetitionUsers] = useState<CompetitionsUsersType[]>();
	const [series, setSeries] = useState<any[]>([]);
	// title opcional: si no se indica se usa el título del aviso de plan no compatible
	const [error, setError] = useState<{ status: boolean, message: string, title?: string }>({ status: false, message: '' });
	const [loading, setLoading] = useState<boolean>(true);
	const user: any = Auth.getUserProfile();
	const [isLoadingMOdelPortfolioToEdit, setIsLoadingModelPortfolioToEdit] = useState<boolean>(false);
	const location = useLocation();
	const isUserSuscribed = Auth.isSubscribed();
	let activePlan = Auth.getActivePlan();
	const { name } = useParams<{ name?: string }>();
	const state = location.state as { competitionId?: string | number } | undefined;
	const competitionId = resolveCompetitionId(state?.competitionId, name);
	const dispatch = useDispatch();

	useEffect(() =>
	{
		// Sin id no hay nada que pedir: la página muestra su mensaje de error de carga
		if(competitionId <= 0)
		{
			setLoading(false);
			return;
		}

		// Si solo fallan los banners se muestra la competición sin patrocinadores
		const bannersRequest = CompetitionsService.getCompetitionBanners(competitionId).catch((): ListOfQuickLinks => ({ quicklinks: [] }));

		Promise.all([CompetitionsService.getCompetition(competitionId), bannersRequest]).then(([competitionData, banners]) =>
		{
			setCompetition(competitionData);
			setBanners(banners ?? { quicklinks: [] })
		},
			(error: any) =>
			{
				// Sin competición la página muestra su mensaje de error de carga; no se guarda el error de axios en el estado del modal
				console.error("Error al cargar la competición", error);
			}).finally(() =>
			{
				setLoading(false);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() =>
	{
		if (competition !== undefined)
		{
			if (competition.ratioId == null || competition.ratioId === undefined)
			{
				var competitionsUsers = competition.competitionsUsers.map((competitionUser: CompetitionsUsersType) =>
				{
					let performance = 0;
					const valueVirtualPortfolios = competitionUser.portfolioModel.valueVirtualPortfolios;

					if (valueVirtualPortfolios.length !== 0 && valueVirtualPortfolios[0].ammount !== 0)
					{
						const amountDistintInitial = valueVirtualPortfolios.filter(vVP => vVP.ammount !== valueVirtualPortfolios[0].ammount);
						if (amountDistintInitial.length > 0)
						{
							performance = (amountDistintInitial[amountDistintInitial.length - 1].ammount - valueVirtualPortfolios[0].ammount) / valueVirtualPortfolios[0].ammount;
						}
					}
					competitionUser.performance = performance;
					return competitionUser;
				});

				if (competition.ratioId != null && competition.ratioId !== undefined)
				{
					const sortedCompetitionsUsers = competitionsUsers.sort((a: CompetitionsUsersType, b: CompetitionsUsersType) => ((a.ratio ?? 0) > (b.ratio ?? 0) ? -1 : 1));
					setCompetitionUsers(sortedCompetitionsUsers);
				}
				else
				{
					const sortedCompetitionsUsers = competitionsUsers.sort((a: CompetitionsUsersType, b: CompetitionsUsersType) => ((a.performance ?? 0) > (b.performance ?? 0) ? -1 : 1));
					setCompetitionUsers(sortedCompetitionsUsers);
				}
			}
			else
			{
				const sortedCompetitionsUsers = competition.competitionsUsers.sort((a: CompetitionsUsersType, b: CompetitionsUsersType) => ((a.ratio ?? 0) > (b.ratio ?? 0) ? -1 : 1));
				setCompetitionUsers(sortedCompetitionsUsers);
			}
		}
	}, [competition]);

	useEffect(() =>
	{
		if (competitionUsers !== undefined)
		{
			var seriesAux: any[] = [];
			competitionUsers.forEach((competitionUser: CompetitionsUsersType) =>
			{
				var serie: any[] = [];
				competitionUser.portfolioModel.jsonFundsData.forEach((dataAndCartLine: DataAndCartLines) =>
				{
					serie.push(
						{
							name: dataAndCartLine.fund.name,
							data: [dataAndCartLine.modelPercentage]
						});
				});
				seriesAux.push(serie.sort((serieItemA, serieItemB) => serieItemA.data[0] - serieItemB.data[0]));
			});
			setSeries(seriesAux);
		}
	}, [competitionUsers]);

	const isCompetitionIniciated = () =>
	{
		const competitionStartDate = parseCompetitionDate(competition?.startDate);
		if (competitionStartDate !== null && competitionStartDate <= new Date())
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	const competitionEndDate = parseCompetitionDate(competition?.endDate);

	const getPortfolioModel = async (savingPlanId?: number, portfolioModelId?: number) =>
	{
		setIsLoadingModelPortfolioToEdit(true);

		const competitionInfo: ICompetitionInfo =
		{
			name: competition!.name!,
			competitionId: competitionId,
			isPromotionated: competition!.isPromocionated!,
			origin: "edit_model_portfolio"
		};

		portfolioModelWallets.getModelWallet(portfolioModelId!).then((response: ModelWallet) =>
		{
			if (response !== undefined && response !== null)
			{
				if (response.savingPlanType === SavingsPlanTypes.FinancialEducation)
				{
					dispatch(clearCartEP());
					let modelPercentageTotal = 0;
					response.jsonFundsData.map((item) =>
					{
						modelPercentageTotal += item.modelPercentage;
						return dispatch(addLineEP(
							{
								fund: item.fund,
								amount: 0,
								modelPercentage: item.modelPercentage,
								readOnly: item.readOnly,
								savingsPlanId: item.savingPlanId,
							}));
					});

					dispatch(updateModelPercentageTotal(modelPercentageTotal));
					dispatch(cartStateEP(CartModesEP.EDIT_MODEL_PORTFOLIO));
					dispatch(updateModelPortfolioNameEP(response.name));
					dispatch(updateModelPortfolioIdEP(portfolioModelId!.toString()));
					dispatch(addCompetitionDataInLs(competitionInfo));
					history.push(
						{
							pathname: `/cart-ef`,
							state:
							{
								savingPlanType: response.savingPlanType,
								portfolioModelId: portfolioModelId,
							},
						});
				}
				else
				{
					dispatch(clearCart());
					let modelPercentageTotal = 0;
					response.jsonFundsData.map((item) =>
					{
						modelPercentageTotal += item.modelPercentage;
						return dispatch(addLine(
							{
								fund: item.fund,
								amount: 0,
								modelPercentage: item.modelPercentage,
								readOnly: item.readOnly,
								savingsPlanId: item.savingPlanId,
							}));
					});

					var item: any =
					{
						planId: response.savingPlan.id,
						planName: response.savingPlan?.name,
						userId: user.id,
						type: response.savingPlan?.type,
						status: 4,
						portfolio: response.savingPlan?.portfolio,
						finametrixContract: response.savingPlan?.finametrixContract,
						userSubscriptionId: response.savingPlan?.usersSubscriptionId
					};

					Auth.setActivePlan(item);
					activePlan = Auth.getActivePlan();

					dispatch(updateModelPercentageTotal(modelPercentageTotal));
					dispatch(cartState(CartModes.EDIT_MODEL_PORTFOLIO));
					dispatch(updateModelPortfolioNameEP(response.name));
					dispatch(updateModelPortfolioIdEP(portfolioModelId!.toString()));
					dispatch(addCompetition(competitionId));
					dispatch(addCompetitionData(competitionInfo));
					history.push(
						{
							pathname: `/cart`,
							state:
							{
								savingPlanType: response.savingPlanType,
								portfolioModelId: portfolioModelId,
							},
						});
				}
			}
		})
			.catch((error: any) =>
			{
				setError({ status: true, title: "Ha ocurrido un error al procesar tu solicitud", message: (typeof error?.response?.data === "string" && error.response.data) || "No se ha podido cargar tu cartera modelo. Por favor, inténtalo de nuevo más tarde." });
			})
			.finally(() =>
			{
				setIsLoadingModelPortfolioToEdit(false);
				setLoading(false);
			});
	};

	return (
		<DocumentTitle title={`IronIA - Competición`}>
			<React.Fragment>
				{loading && (<Spinner size={SpinnerSize.large} />)}
				{(!loading && competition === undefined && <p>Se ha producido un error al traer la información.</p>)}
				{(!loading && competition !== undefined) &&
					(
						<React.Fragment>
							<section className={`${styles.competition_p}`}>
								<BackButton />
								<div className="ms-Grid-row">
									<div style={{ display: "flex" }}>
										<h2 style={{ cursor: "default" }}>{competition?.name}</h2>
										{competitionUsers?.some(e => e.userId === user.id) && <div style={{ display: "flex", justifyContent: "right", textAlign: "center" }}>
											{isLoadingMOdelPortfolioToEdit && (<Spinner size={SpinnerSize.large} style={{ marginRight: "20px" }} />)}
											<PrimaryButton className="rounded" style={{ width: "170px" }}
												onClick={() =>
												{
													const competitionFromUser = competitionUsers?.find(e => e.userId === user.id)
													getPortfolioModel(competitionFromUser?.savingsPlanId, competitionFromUser?.portfolioModelId);
												}}
											>
												Cambiar Cartera
											</PrimaryButton>
										</div>}
										{(!competitionUsers?.some(e => e.userId === user.id)
											&& competitionEndDate !== null && competitionEndDate >= new Date()
											&& ((competition.allowOutdatedIncriptions === true) || (competition.allowOutdatedIncriptions === false && !isCompetitionIniciated())))
											&& <div style={{ display: "flex", justifyContent: "right", width: "170px", textAlign: "center" }}>
												<PrimaryButton className="rounded"
													onClick={async () =>
													{
														// Con un plan gestionado como activo solo se bloquea si no hay otro plan compatible
														if (!(await canJoinCompetitionWithPlans(activePlan, user?.id)))
														{
															setError({ status: true, message: ManagedPlanOnlyMessage })
														}
														else
														{
															isUserSuscribed ? history.push(`/competitions/join/${competition.id}`) : history.push(`/competitions/join/nsv/${competition.id}`);
														}
													}}
												>
													Participar
												</PrimaryButton>
											</div>
										}
									</div>
									<div className="ms-Grid-col ms-sm12" style={{ marginTop: "16px", cursor: "default" }}>
										{/* Sumario saneado con lista blanca de etiquetas (auditoría G4-07) */}
										<div dangerouslySetInnerHTML={{ __html: sanitizeCompetitionHtml(competition?.summary) }} />
									</div>
									<div className="ms-Grid-row" style={{ cursor: "default" }}>
										<p className="ms-Grid-col ms-sm1" style={{ marginTop: "20px" }}>Tipo: {CompetitionTypes[competition?.type || 0]}</p>
										<div className="ms-Grid-col ms-sm2" style={{ marginTop: "20px", cursor: "default" }}>
											<p>
												Precio:{" "}
												{competition?.price === 0 && <>Inscripción gratuita &nbsp;</>}
												{competition?.price !== 0 && competition?.typeOfPrice === 0 &&
													<>{currencyNeutreFormatter.format(competition.price)}{" "} Elements IA </>
												}
												{competition?.typeOfPrice === 1 &&
													<>{currencyNeutreFormatter.format(competition.price)}{" "} Elements Agua</>
												}
												{(competition.typeOfPrice === 2 || competition.typeOfPrice === 3) &&
													<>{currencyNeutreFormatter.format(competition.price)}{" "} €</>
												}
											</p>
										</div>
										<p className="ms-Grid-col ms-sm2" style={{ marginTop: "20px" }}>Métrica: {competition.ratioName !== undefined ? competition.ratioName : "Rentabilidad"}</p>
									</div>
								</div>
								<div style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: "20px" }}>
									<div className="ms-Grid-col ms-sm2">
										<CardWithInfo title="Información"
											body=
											{
												<div>
													<div>
														<p>Comienzo: {formatCompetitionDate(competition?.startDate)}</p>
														<p>Final:  {formatCompetitionDate(competition?.endDate)}</p>
													</div>
													{competition !== undefined && <CountdownTimer startDate={competition.startDate} endDate={competition.endDate} />}
												</div>
											}
										/>
									</div>
									{competition?.firstPrice !== undefined &&
										(
											<div className="ms-Grid-col ms-sm2">
												<CardWithInfo title="Primer Premio"
													body=
													{
														<div>
															<p>{competition?.firstPrice}</p>
														</div>
													}
												/>
											</div>
										)}
									{competition?.secondPrice !== undefined &&
										(
											<div className="ms-Grid-col ms-sm2">
												<CardWithInfo title="Segundo Premio"
													body=
													{
														<div>
															<p>{competition?.secondPrice}</p>
														</div>
													}
												/>
											</div>
										)}
									{competition?.thirdPrice !== undefined &&
										(
											<div className="ms-Grid-col ms-sm2">
												<CardWithInfo title="Tercer Premio"
													body=
													{
														<div>
															<p>{competition?.thirdPrice}</p>
														</div>
													}
												/>
											</div>
										)}
									<div className="ms-Grid-col ms-sm2" />
									{
										competition?.specialPrice !== undefined &&
										(
											<div className="ms-Grid-col ms-sm2">
												<CardWithInfo title="Premio Especial"
													body=
													{
														<div>
															<p>{competition?.specialPrice}</p>
														</div>
													}
												/>
											</div>
										)
									}
								</div>
								{banners !== undefined && (banners?.quicklinks?.length ?? 0) > 0 && <div className="ms-Grid-row" style={{ margin: "20px" }}>
									<L.CompetitionPatronitedPatrocin>PATROCINADORES</L.CompetitionPatronitedPatrocin>
									<CompetitionQuickLinks quicklinks={banners?.quicklinks || []} />
								</div>}
								{competitionUsers && competitionUsers.length > 0 &&
									(
										<section className="ms-Grid-row">
											<div className={`${styles.tableContainer_p} background-tertiary`}>
												<div className={styles.tableScroll}>
													<table>
														<thead className="background-shadow">
															<tr>
																{/* {isCompetitionIniciated() && <td className={styles.positionHead}>#</td>}
                                                        {isCompetitionIniciated() && <td className={styles.performanceHead}>{competition.ratioId != null ? competition.ratioName : "Rentabilidad"}</td>} */}
																<td className={styles.positionHead}>#</td>
																<td className={styles.nameHead}>Cartera</td>
																<td className={styles.performanceHead}>{competition.ratioId != null ? competition.ratioName : "Sharpe"}</td>
																<td className={styles.performanceHead}>Volatilidad</td>
																<td className={styles.performanceHead}>Rentabilidad</td>
																<td className={styles.compositionHead}>Composición</td>
															</tr>
														</thead>
														<tbody>
															{
																competitionUsers.map((competitionUser, competitionUserIndex) =>
																(
																	<tr key={`competitionUserIndex${competitionUserIndex}`}>
																		<td className={styles.position}>{competitionUserIndex + 1}</td>
																		<td className={styles.name}>{competitionUser.portfolioModel.name}</td>
																		<td className={styles.performance}>{competition.ratioId != null && competition.ratioId !== undefined ? decimalFormatter.format(competitionUser.ratio ?? 0) : decimalFormatter.format(competitionUser.performance ?? 0)}</td>
																		<td className={styles.performance}>{decimalFormatter.format((competitionUser.volatility ?? 0) * 100)}%</td>
																		<td className={styles.performance}>{decimalFormatter.format((competitionUser.profitability ?? 0) * 100)}%</td>
																		<td className={styles.composition}>
																			<HighchartsReact highcharts={Highcharts}
																				options={
																					{
																						...options,
																						series: series[competitionUserIndex]
																					}}
																			/>
																		</td>
																	</tr>
																))
															}
														</tbody>
													</table>
												</div>
											</div>
										</section>
									)}
							</section>
							<ErrorModal title={error.title ?? "Tu Plan actual no es compatible con la competición"} btnSubmitText="Aceptar" showModal={error.status}
								body=
								{
									<div>
										<p>{error.message}</p>
									</div>
								}
								onSubmit={() =>
								{
									setError({ status: false, message: "" });
								}}
								onClose={() =>
								{
									setError({ status: false, message: "" });
								}}
							/>
						</React.Fragment>
					)}
			</React.Fragment>
		</DocumentTitle>
	);
};

export default CompetitionPromotionated;